var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"radio-item"},[_c('RadioButton',{staticClass:"radio-btn",attrs:{"paymentId":_vm.paymentId,"isChecked":_vm.isChecked},on:{"handleRadioBtnClick":_vm.handleRadioBtnClick}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.name))]),_c('span',{staticClass:"note"},[_vm._v(_vm._s(_vm.memo))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }